import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type React from 'react';

export interface IProps {
  onClose?: () => void;
  onCancel?: () => void;
}

const CloseBtn: React.FC<IProps> = ({ onClose, onCancel }) => {
  return (
    <div data-testid="dialog-close-btn">
      <FontAwesomeIcon
        className="cursor-pointer text-xl text-gray-500"
        icon={faTimes}
        onClick={onClose ?? onCancel}
      />
    </div>
  );
};

export default CloseBtn;
